import React from 'react';
import { FaFacebook } from 'react-icons/fa';

interface FacebookShareButtonProps {
  link: string;
  title?: string;
}

const FacebookShareButton: React.FC<FacebookShareButtonProps> = ({
  link,
  title = 'Dela på Facebook'
}) => {
  const handleFacebookShare = () => {
    // För mobila enheter, använd native share funktion
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile && navigator.share) {
      // Använd telefons native delningsfunktion
      navigator.share({
        url: link
      }).catch((error) => {
        console.log('Share failed:', error);
      });
    } else {
      // För desktop eller om native share inte finns, öppna Facebook web-version
      const facebookWebUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
      window.open(facebookWebUrl, '_blank', 'width=600,height=400');
    }
  };

  return (
    <a
      onClick={handleFacebookShare}
      className="facebook-share-button"
      title={title}
      href="#"
    >
      <FaFacebook size={24} />
      <span>Facebook</span>
    </a>
  );
};

export default FacebookShareButton;
